<script lang="ts">
	import { onMount } from 'svelte';
	import Ui from './Ui.svelte';

	enum Panel {
		details,
		apply
	}
	export let contentDivId: string;
	export let action: string;
	export let uploadAction: string;
	export let ajaxSubmitURL: string;
	export let jobId: string;
	export let jobTitle: string;
	let contentHTML: string;
	let panel: Panel = Panel.details;
	onMount(() => {
		const div = document.getElementById(contentDivId);
		contentHTML = div.innerHTML;
		div.remove();
	});
</script>

<ul class="tabs-list" id="details-apply-tabs" role="tablist">
	<li class="nav-item" class:active={panel === Panel.details} role="presentation">
		<button
			class="nav-link"
			class:active={panel === Panel.details}
			id="details-tab"
			type="button"
			role="tab"
			aria-controls="details"
			aria-selected={panel === Panel.details}
			on:click={() => (panel = Panel.details)}
		>
			Details
		</button>
	</li>
	<li class="nav-item" class:active={panel === Panel.apply} role="presentation">
		<button
			class="nav-link"
			class:active={panel === Panel.apply}
			id="apply-tab"
			type="button"
			role="tab"
			aria-controls="apply"
			aria-selected={panel === Panel.apply}
			on:click={() => (panel = Panel.apply)}
		>
			Apply Now
		</button>
	</li>
</ul>
<div class="tab-content my-3" id="details-apply-content">
	<div
		class="tab-pane"
		class:active={panel === Panel.details}
		id="details"
		role="tabpanel"
		aria-labelledby="details-tab"
	>
		{@html contentHTML}
	</div>
	<div
		class="tab-pane"
		class:active={panel === Panel.apply}
		id="apply"
		role="tabpanel"
		aria-labelledby="apply-tab"
	>
		<Ui {action} {ajaxSubmitURL} {uploadAction} {jobTitle} {jobId} />
	</div>
</div>

<style lang="scss">
	@import '../../node_modules/bootstrap/scss/functions';
	@import '../../node_modules/bootstrap/scss/mixins';
	@import '../../node_modules/bootstrap/scss/variables';
	$borderColor: $gray-300;
	.tab-content {
		margin: $spacer 0 ($spacer * 3) 0;
	}
	.tabs-list {
		list-style: none;
		display: flex;
		margin: 0;
		padding: 0;
		border-bottom: 1px solid $borderColor;
	}
	.tab-pane {
		display: none;
		opacity: 0;
		transition: opacity 0.5s ease-in-out;
		&.active {
			display: block;
			opacity: 1;
		}
	}
	button.nav-link {
		box-sizing: border-box;
		background-color: transparent !important;
		font-family: inherit;
		padding: 6px 12px;
		cursor: pointer;
		color: $primary !important;
		text-decoration: underline;
		border: 1px solid transparent;
		border-bottom: 1px solid $borderColor;
		border-top-left-radius: 6px;
		border-top-right-radius: 6px;
		position: relative;
		top: 1px;
		margin-left: $spacer;
		&.active {
			color: $gray-600 !important;
			text-decoration: none;
			border-bottom: 1px solid $white;
			border-top: 1px solid $borderColor;
			border-left: 1px solid $borderColor;
			border-right: 1px solid $borderColor;
		}
	}
</style>
